import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

export const OutcomeSelector = ({ outcome, setOutcome, yesPrice, noPrice, orderbook }) => {
  return (
    <div className="grid grid-cols-2 gap-3">
      <button
        onClick={() => setOutcome('YES')}
        data-testid="yes-outcome-btn"
        className={`p-4 rounded-xl transition-all ${
          outcome === 'YES'
            ? 'bg-[#3B82F6] text-white shadow-lg shadow-[#3B82F6]/25'
            : 'bg-[#1e2a45] text-gray-300 hover:bg-[#2d3a56]'
        }`}
      >
        <div className="flex justify-between items-center mb-1">
          <span className="font-semibold">YES</span>
          <TrendingUp className="h-4 w-4" />
        </div>
        <div className="text-2xl font-bold">{yesPrice}¢</div>
        <div className="text-xs opacity-70">
          Bid: {orderbook?.yes?.best_bid || 0}¢ | Ask: {orderbook?.yes?.best_ask || 100}¢
        </div>
      </button>

      <button
        onClick={() => setOutcome('NO')}
        data-testid="no-outcome-btn"
        className={`p-4 rounded-xl transition-all ${
          outcome === 'NO'
            ? 'bg-[#F97316] text-white shadow-lg shadow-[#F97316]/25'
            : 'bg-[#1e2a45] text-gray-300 hover:bg-[#2d3a56]'
        }`}
      >
        <div className="flex justify-between items-center mb-1">
          <span className="font-semibold">NO</span>
          <TrendingDown className="h-4 w-4" />
        </div>
        <div className="text-2xl font-bold">{noPrice}¢</div>
        <div className="text-xs opacity-70">
          Bid: {orderbook?.no?.best_bid || 0}¢ | Ask: {orderbook?.no?.best_ask || 100}¢
        </div>
      </button>
    </div>
  );
};
